// extracted by css-extract-rspack-plugin
export default {"installableAppAccessRadioButtonsContainer":"installableAppAccessRadioButtonsContainer__MwgIL","installableAppAccessLabelContainer":"installableAppAccessLabelContainer__UOD_H"};